import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './AutomaticReconnectionMessage.module.scss';

function AutomaticReconnectionMessage({
  timerSec,
  isRetryInPending,
}: {
  timerSec: number | undefined;
  isRetryInPending: boolean;
}) {
  if (isRetryInPending || timerSec === undefined) {
    return null;
  }

  return (
    <div className={styles.autoReconnectionMsg}>
      <FormattedMessage
        defaultMessage={`Automatic reconnection in ${timerSec} seconds`}
        id='Error.automaticReconnectionMessage'
        values={{ timerSec }}
      />
    </div>
  );
}

export default AutomaticReconnectionMessage;
